import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { toast } from "react-toastify";
import IsLoadingHOC from "./IsLoadingHOC";
import { authAxios } from "../config/config";

const ForgotPassword = ({setLoading}) => {
  const navigate = useNavigate();

  const [email, setemail] = useState('')

  const handleSubmit=async(e)=>{
    e.preventDefault()
    setLoading(true);
    const payload = {
      email: email.toLowerCase(),
    };
    await authAxios()
      .post(`/auth/forgot-password`, payload)
      .then((response) => {
        const resData = response?.data;
        setLoading(false);
        if (resData.status == 1) {
          sessionStorage.setItem("email",email)
          toast.success(resData?.message);
          navigate('/verify-otp')
        } else {
          console.log("err",resData)
          toast.error(resData?.message);
        }
      })
      .catch((error) => {
        console.log(error)
        setLoading(false);
        toast.error(error?.response?.data?.message||error?.message);
      });
  }

  return (
    <div className="flex shadow-lg flex-1 flex-col justify-center px-5 py-6 rounded-[20px] lg:px-5 bg-white border max-w-[400px] mx-auto absolute w-[95%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
      <div className="sm:mx-auto sm:w-full">
        <img
          className="mx-auto h-20 w-auto"
          src="./assets/images/final-logo.png"
          alt="Your Company"
        />
        <h2 className="mt-2 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Forgot Password
        </h2>
      </div>

      <div className="mt-5 sm:mx-auto sm:w-full ">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e)=>setemail(e?.target?.value)}
                required
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm"
            >
              Submit 
            </button>
          </div>
          <p className="text-center cursor-pointer" onClick={()=>navigate("/")}>
            <span className="font-bold m-2 flex flex-row items-center justify-center gap-2"><IoIosArrowBack /> Back to Login </span></p>
        </form>
      </div>
      
    </div>
  );
};

export default IsLoadingHOC(ForgotPassword);
